import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sun, Check, Euro, Calendar, Award } from 'lucide-react';

const SolutionSolaire = () => {
  return (
    <div style={{ background: 'var(--bg-page)', minHeight: '100vh' }}>
      {/* Hero */}
      <section style={{ paddingTop: '140px', paddingBottom: '64px', background: 'var(--bg-card)' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '48px', alignItems: 'center' }}>
            <div>
              <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: 'var(--brand-primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '24px' }}>
                <Sun size={32} style={{ color: 'var(--brand-dark)' }} />
              </div>
              <h1 className="display-medium" style={{ color: 'var(--text-primary)', marginBottom: '24px' }}>
                Installation Panneaux Solaires Photovoltaïques
              </h1>
              <p className="body-large" style={{ color: 'var(--text-secondary)', marginBottom: '32px' }}>
                Produisez votre propre électricité verte et réduisez vos factures jusqu'à 40%. Installation clé en main avec accompagnement aux aides de l'État.
              </p>
              <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                <Link to="/devis" className="btn-primary" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                  Demander un devis gratuit
                  <ArrowRight size={20} />
                </Link>
                <a href="tel:0175438580" className="btn-secondary">
                  01 75 43 85 80
                </a>
              </div>
            </div>
            <div>
              <img src="https://images.unsplash.com/photo-1508514177221-188b1cf16e9d" alt="Panneaux solaires" style={{ width: '100%', borderRadius: '32px' }} />
            </div>
          </div>
        </div>
      </section>

      {/* Avantages */}
      <section className="pad-giant">
        <div className="container">
          <h2 className="heading-1" style={{ textAlign: 'center', marginBottom: '48px', color: 'var(--text-primary)' }}>
            Les Avantages du Solaire
          </h2>
          <div className="network-grid">
            <div className="network-card">
              <Euro size={32} style={{ color: 'var(--brand-primary)', marginBottom: '16px' }} />
              <h3 className="network-card-title">Jusqu'à 40% d'Économies</h3>
              <p className="network-card-content">
                Réduisez considérablement votre facture d'électricité en produisant votre propre énergie.
              </p>
            </div>
            <div className="network-card">
              <Calendar size={32} style={{ color: 'var(--brand-primary)', marginBottom: '16px' }} />
              <h3 className="network-card-title">Garantie 25 Ans</h3>
              <p className="network-card-content">
                Panneaux garantis 25 ans avec un rendement supérieur à 80% après 25 ans.
              </p>
            </div>
            <div className="network-card">
              <Award size={32} style={{ color: 'var(--brand-primary)', marginBottom: '16px' }} />
              <h3 className="network-card-title">Installation RGE QualiPV</h3>
              <p className="network-card-content">
                Installation certifiée pour bénéficier des aides de l'État (MaPrimeRénov', CEE).
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Comment ça marche */}
      <section className="pad-giant" style={{ background: 'var(--bg-card)' }}>
        <div className="container">
          <h2 className="heading-1" style={{ textAlign: 'center', marginBottom: '48px', color: 'var(--text-primary)' }}>
            Comment Ça Marche ?
          </h2>
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            {[
              { num: 1, title: 'Étude de faisabilité', desc: 'Analyse de votre toiture et de votre consommation pour dimensionner l\'installation optimale.' },
              { num: 2, title: 'Visite technique', desc: 'Un technicien RGE vérifie la faisabilité et prend les mesures nécessaires.' },
              { num: 3, title: 'Montage des aides', desc: 'Nous gérons MaPrimeRénov\' et les CEE. Vous ne payez que le reste à charge.' },
              { num: 4, title: 'Installation (2-3 jours)', desc: 'Pose des panneaux, onduleur et raccordement. Mise en service et formation.' },
            ].map((step, index) => (
              <div key={index} style={{ display: 'flex', gap: '24px', marginBottom: '32px', alignItems: 'start' }}>
                <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: 'var(--brand-primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: '24px', fontWeight: '700', color: 'var(--brand-dark)' }}>
                  {step.num}
                </div>
                <div>
                  <h3 style={{ fontSize: '20px', fontWeight: '600', color: 'var(--text-primary)', marginBottom: '8px' }}>{step.title}</h3>
                  <p style={{ fontSize: '16px', color: 'var(--text-secondary)', lineHeight: '1.6' }}>{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Aides */}
      <section className="pad-giant">
        <div className="container">
          <h2 className="heading-1" style={{ textAlign: 'center', marginBottom: '24px', color: 'var(--text-primary)' }}>
            Aides Financières Disponibles
          </h2>
          <p className="body-large" style={{ textAlign: 'center', color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto 48px' }}>
            Profitez des aides de l'État pour financer votre installation solaire
          </p>
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {[
                'Prime à l\'autoconsommation jusqu\'à 2 800€',
                'TVA réduite à 10% (au lieu de 20%)',
                'Revente du surplus à EDF OA',
                'Éco-PTZ : prêt à taux zéro jusqu\'à 50 000€',
              ].map((item, index) => (
                <li key={index} style={{ display: 'flex', alignItems: 'center', gap: '16px', padding: '16px', background: index % 2 === 0 ? 'var(--bg-card)' : 'transparent', borderRadius: '12px', marginBottom: '8px' }}>
                  <Check size={24} style={{ color: 'var(--brand-primary)', flexShrink: 0 }} />
                  <span style={{ fontSize: '18px', color: 'var(--text-secondary)' }}>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="pad-giant" style={{ background: 'var(--brand-dark)', textAlign: 'center' }}>
        <div className="container">
          <h2 className="heading-1" style={{ color: 'white', marginBottom: '24px' }}>
            Prêt à Passer au Solaire ?
          </h2>
          <p className="body-large" style={{ color: 'white', opacity: 0.9, maxWidth: '700px', margin: '0 auto 48px' }}>
            Obtenez votre devis personnalisé gratuit en 2 minutes
          </p>
          <Link to="/devis" className="btn-cta" style={{ background: 'var(--brand-primary)', color: 'var(--brand-dark)' }}>
            Demander mon devis gratuit
          </Link>
        </div>
      </section>
    </div>
  );
};

export default SolutionSolaire;
